import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { config } from '../global/config';

export const LOGOUT_KEY = 'global-logout-timestamp';

export function useMultiTabLogout() {
  const auth = useAuth();
  const pendingLogoutRef = useRef(false);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === LOGOUT_KEY && event.newValue !== null) {
        pendingLogoutRef.current = true;
      }
    };

    globalThis.addEventListener('storage', handleStorageChange);

    const tryLogoutIfPending = () => {
      if (!pendingLogoutRef.current) return;

      pendingLogoutRef.current = false;

      auth.removeUser().catch(console.error);
      globalThis.location.href = `${config.idpAuthority}/Account/Login`;
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        tryLogoutIfPending();
      }
    };

    const onFocus = () => {
      tryLogoutIfPending();
    };

    const onPageshow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        tryLogoutIfPending();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    globalThis.addEventListener('focus', onFocus);
    globalThis.addEventListener('pageshow', onPageshow);

    return () => {
      globalThis.removeEventListener('storage', handleStorageChange);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      globalThis.removeEventListener('focus', onFocus);
      globalThis.removeEventListener('pageshow', onPageshow);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  const triggerLogout = () => {
    localStorage.setItem(LOGOUT_KEY, Date.now().toString());

    setTimeout(() => {
      localStorage.removeItem(LOGOUT_KEY);
    }, 8000);
  };

  return {
    triggerLogout,
  };
}
